import { render, staticRenderFns } from "./msg-box.vue?vue&type=template&id=52255536"
import script from "./msg-box.vue?vue&type=script&lang=js"
export * from "./msg-box.vue?vue&type=script&lang=js"
import style0 from "./msg-box.vue?vue&type=style&index=0&id=52255536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports